var _a, _b, _c, _d;
import { Allergy, DietType, Interest, MedicalCondition } from "../../../models/profile/preference.model";
// null = no fitting glyph: the chip shows its category's fallback icon.
export var ALLERGY_ICONS = (_a = {},
    _a[Allergy.MILK] = { glyph: "milk" },
    _a[Allergy.TREE_NUTS] = { glyph: "acorn" },
    _a[Allergy.EGGS] = { glyph: "boiled-egg" },
    _a[Allergy.PEANUTS] = { glyph: "peanut" },
    _a[Allergy.FISH] = { glyph: "fish" },
    _a[Allergy.WHEAT] = { glyph: "wheat" },
    _a[Allergy.SHELLFISH] = { glyph: "crab" },
    _a[Allergy.SOYBEANS] = { glyph: "soybean" },
    _a[Allergy.CELERY] = null,
    _a[Allergy.MUSTARD] = { glyph: "mustard-bottle" },
    _a[Allergy.SESAME] = { glyph: "seed" },
    _a[Allergy.SULPHITES] = { glyph: "wine-glass" },
    _a[Allergy.LUPIN] = null,
    _a[Allergy.MOLLUSCS] = { glyph: "squid" },
    _a[Allergy.LACTOSE] = { glyph: "cheese" },
    _a[Allergy.GARLIC] = { glyph: "garlic" },
    _a[Allergy.PAPRIKA] = { glyph: "bell-pepper" },
    _a[Allergy.FRUCTOSE] = { glyph: "apple" },
    _a[Allergy.ONION] = { glyph: "onion" },
    _a[Allergy.RAW_FRUIT] = { glyph: "cherry" },
    _a[Allergy.CITRUS] = { glyph: "lemon" },
    _a[Allergy.TOMATO] = { glyph: "tomato" },
    _a[Allergy.MUSHROOMS] = { glyph: "mushroom" },
    _a[Allergy.HISTAMINE] = null,
    _a[Allergy.FEATHERS] = { glyph: "feather" },
    _a[Allergy.ANIMAL_HAIR] = { glyph: "paw" },
    _a[Allergy.DUST_MITES] = { glyph: "pest-bug" },
    _a);
export var DIET_ICONS = (_b = {},
    _b[DietType.VEGETARIAN] = { glyph: "salad" },
    _b[DietType.VEGAN] = { glyph: "leaf" },
    _b[DietType.PESCATARIAN] = { glyph: "fish" },
    _b[DietType.GLUTEN_FREE] = { glyph: "wheat", off: true },
    _b[DietType.LACTOSE_FREE] = { glyph: "milk", off: true },
    _b[DietType.LOW_CARB] = { glyph: "bread", off: true },
    _b[DietType.HALAL] = { glyph: "halal-mark" },
    _b[DietType.KOSHER] = { glyph: "star-of-david" },
    _b[DietType.NO_ALCOHOL] = { glyph: "no-alcohol" },
    _b[DietType.NO_PORK] = { glyph: "pig", off: true },
    _b);
export var MEDICAL_ICONS = (_c = {},
    _c[MedicalCondition.PREGNANT] = { glyph: "pregnant-woman" },
    _c[MedicalCondition.DIABETES] = { glyph: "insulin-pen" },
    _c[MedicalCondition.HYPERTENSION] = { glyph: "blood-pressure" },
    _c[MedicalCondition.BACK_NECK] = { glyph: "back-pain" },
    _c[MedicalCondition.ASTHMA] = { glyph: "inhaler" },
    _c[MedicalCondition.MOBILITY] = { glyph: "wheelchair" },
    _c[MedicalCondition.HEARING_SIGHT] = { glyph: "hearing-aid" },
    _c[MedicalCondition.SURGERY] = { glyph: "crutches" },
    _c[MedicalCondition.CANCER] = { glyph: "awareness-ribbon" },
    _c);
export var INTEREST_ICONS = (_d = {},
    _d[Interest.MASSAGES] = { glyph: "massage-hands" },
    _d[Interest.SPA_BEAUTY] = { glyph: "lotus" },
    _d[Interest.FINE_DINING] = { glyph: "fork-knife" },
    _d[Interest.CULTURE] = { glyph: "theater-masks" },
    _d[Interest.SIGHTSEEING] = { glyph: "binoculars" },
    _d[Interest.HIKING] = { glyph: "hiking" },
    _d[Interest.BIKING] = { glyph: "bike" },
    _d[Interest.FAMILY] = { glyph: "family" },
    _d[Interest.COUPLE] = { glyph: "couple" },
    _d[Interest.SKIING] = { glyph: "cross-country-skiing" },
    _d[Interest.DOGS] = { glyph: "dog" },
    _d[Interest.HORSE_RIDING] = { glyph: "horse" },
    _d[Interest.YOGA] = { glyph: "yoga" },
    _d[Interest.WINE] = { glyph: "wine-glass" },
    _d[Interest.GOLF] = { glyph: "golf-swing" },
    _d[Interest.BUSINESS] = { glyph: "briefcase" },
    _d[Interest.TENNIS] = { glyph: "tennis-racket" },
    _d[Interest.FITNESS] = { glyph: "dumbbell" },
    _d[Interest.CELEBRATIONS] = { glyph: "cake" },
    _d);
/** Category icons: values without a glyph, free text and PMS codes. */
export var ALLERGY_FALLBACK_ICON = { glyph: "alert-triangle" };
export var DIET_FALLBACK_ICON = { glyph: "cutlery" };
export var MEDICAL_FALLBACK_ICON = { glyph: "first-aid" };
export var INTEREST_FALLBACK_ICON = { glyph: "heart" };
/** Shown instead of the value's glyph on every AI-found interest. */
export var AI_INTEREST_ICON = { glyph: "ai-sparkle" };
/** Values are stored keys (MILK); free text and PMS codes find nothing. */
export var findValueIcon = function (map, value) { return (value && Object.prototype.hasOwnProperty.call(map, value) ? map[value] : null); };
